import React from 'react';

const Terms = () => {
  return (
    <div>
      {/* Terms Hero Section */}
      <section className="terms-hero">
        <div className="container">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Terms of Service</h1>
          <p className="text-xl max-w-2xl mx-auto">Last updated: September 2023</p>
        </div>
      </section>

      {/* Terms Content */}
      <section className="terms-content">
        <div className="container">
          <div className="max-w-3xl mx-auto">
            <div className="terms-section">
              <h2>1. Agreement to Terms</h2>
              <p>By accessing or using our website and services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing our site.</p>
            </div>
            
            <div className="terms-section">
              <h2>2. Use License</h2>
              <p>Permission is granted to temporarily access the materials (information or software) on Cleophas Network's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.</p>
              
              <p>Under this license you may not:</p>
              
              <ul className="list-disc pl-5 mb-4">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose or for any public display</li>
                <li>Attempt to decompile or reverse engineer any software contained on Cleophas Network's website</li>
                <li>Remove any copyright or other proprietary notations from the materials</li>
                <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
              </ul>
              
              <p>This license shall automatically terminate if you violate any of these restrictions and may be terminated by Cleophas Network at any time.</p>
            </div>
            
            <div className="terms-section">
              <h2>3. Disclaimer</h2>
              <p>The materials on Cleophas Network's website are provided on an 'as is' basis. Cleophas Network makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
              
              <p>Further, Cleophas Network does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</p>
            </div>
            
            <div className="terms-section">
              <h2>4. Limitations</h2>
              <p>In no event shall Cleophas Network or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Cleophas Network's website, even if Cleophas Network or a Cleophas Network authorized representative has been notified orally or in writing of the possibility of such damage.</p>
            </div>
            
            <div className="terms-section">
              <h2>5. Accuracy of Materials</h2>
              <p>The materials appearing on Cleophas Network's website could include technical, typographical, or photographic errors. Cleophas Network does not warrant that any of the materials on its website are accurate, complete, or current. Cleophas Network may make changes to the materials contained on its website at any time without notice.</p>
            </div>
            
            <div className="terms-section">
              <h2>6. Links</h2>
              <p>Cleophas Network has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Cleophas Network of the site. Use of any such linked website is at the user's own risk.</p>
            </div>
            
            <div className="terms-section">
              <h2>7. Modifications</h2>
              <p>Cleophas Network may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>
            </div>
            
            <div className="terms-section">
              <h2>8. Governing Law</h2>
              <p>These terms and conditions are governed by and construed in accordance with the laws of Kenya and you irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
            </div>
            
            <div className="terms-section">
              <h2>9. Contact Information</h2>
              <p>If you have any questions about these Terms of Service, please contact us at:</p>
              
              <div className="bg-blue-50 p-6 rounded-lg mt-6">
                <p className="mb-2">
                  <strong>Email:</strong> info@cleophasnetwork.com
                </p>
                <p className="mb-4">
                  <strong>WhatsApp:</strong> +254 115 647 545
                </p>
                <a href="https://wa.me/254115647545?text=I%20have%20questions%20about%20terms%20of%20service" 
                   className="inline-flex items-center bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg transition-colors text-sm">
                  <i className="fab fa-whatsapp mr-2"></i> Message Us on WhatsApp
                </a>
              </div>
            </div>

            {/* Support Section */}
            <div className="mt-12 bg-gradient-to-r from-blue-50 to-purple-50 p-8 rounded-xl border border-blue-100">
              <h2 className="text-2xl font-bold mb-4 text-blue-800">Need Help Understanding Our Terms?</h2>
              <p className="mb-4">If you have any questions about our terms of service or need clarification on any points, our support team is here to help you.</p>
              
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="https://wa.me/254115647545?text=I%20need%20help%20understanding%20the%20terms%20of%20service" 
                   className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg transition-colors">
                  <i className="fab fa-whatsapp mr-2 text-xl"></i> Chat on WhatsApp
                </a>
                
                <a href="mailto:info@cleophasnetwork.com" 
                   className="inline-flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-6 rounded-lg transition-colors">
                  <i className="fas fa-envelope mr-2 text-xl"></i> Send Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;